(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-clients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('avis-carousel')) {
    class AvisCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.avis__track');
        this.prevBtn = this.querySelector('.avis__btn--prev');
        this.nextBtn = this.querySelector('.avis__btn--next');
        this.dots = Array.from(this.querySelectorAll('.avis__dot'));
        if (!this.track) return;

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.scrollToIndex(parseInt(dot.dataset.index, 10)));
        });

        this.track.addEventListener('scroll', () => this.updateState(), { passive: true });
        window.addEventListener('resize', () => this.updateState());
        this.updateState();
      }

      getStep() {
        const card = this.track.querySelector('.avis__card');
        if (!card) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
        return card.offsetWidth + gap;
      }

      scrollByCard(direction) {
        this.track.scrollBy({ left: this.getStep() * direction, behavior: 'smooth' });
      }

      scrollToIndex(index) {
        const card = this.track.querySelectorAll('.avis__card')[index];
        if (card) this.track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      }

      updateState() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 4;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 4;

        if (this.dots.length) {
          const step = this.getStep();
          const active = step > 0 ? Math.round(this.track.scrollLeft / step) : 0;
          this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
        }
      }
    }
    customElements.define('avis-carousel', AvisCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-block"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-carousel-track')) {
    class ReviewCarouselTrack extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.reviews-block__track, .review-carousel__track');
        this.prevBtn = this.querySelector('.reviews-block__btn--prev, .review-carousel__btn--prev');
        this.nextBtn = this.querySelector('.reviews-block__btn--next, .review-carousel__btn--next');
        this.dots = Array.from(this.querySelectorAll('.reviews-block__dot'));
        if (!this.track) return;

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByCard(1));

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.scrollToIndex(parseInt(dot.dataset.index, 10)));
        });

        this.track.addEventListener('scroll', () => this.updateState());
        window.addEventListener('resize', () => this.updateState());
        this.updateState();
      }

      getCardWidth() {
        const card = this.track.querySelector('.reviews-block__card, .review-carousel__item');
        return card ? card.offsetWidth : 0;
      }

      scrollByCard(direction) {
        const card = this.track.querySelector('.reviews-block__card, .review-carousel__item');
        if (!card) return;
        const gap = 20;
        const amount = (card.offsetWidth + gap) * direction;
        this.track.scrollBy({ left: amount, behavior: 'smooth' });
      }

      scrollToIndex(index) {
        const cards = this.track.querySelectorAll('.reviews-block__card, .review-carousel__item');
        const card = cards[index];
        if (!card) return;
        this.track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      }

      updateState() {
        if (this.prevBtn && this.nextBtn) {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          this.prevBtn.disabled = this.track.scrollLeft <= 4;
          this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 4;
        }

        if (this.dots.length) {
          const cardWidth = this.getCardWidth() + 20;
          const activeIndex = cardWidth > 0 ? Math.round(this.track.scrollLeft / cardWidth) : 0;
          this.dots.forEach((dot, i) => {
            dot.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
          });
        }
      }
    }
    customElements.define('review-carousel-track', ReviewCarouselTrack);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-carousel-track')) {
    class VideoCarouselTrack extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.vcar__track');
        this.prevBtn = this.querySelector('.vcar__btn--prev');
        this.nextBtn = this.querySelector('.vcar__btn--next');
        this.dots = Array.from(this.querySelectorAll('.vcar__dot'));
        if (!this.track) return;

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.scrollToIndex(parseInt(dot.dataset.index, 10)));
        });

        this.track.addEventListener('scroll', () => this.updateState(), { passive: true });
        window.addEventListener('resize', () => this.updateState());
        this.updateState();
        this.setupAutoplay();
      }

      /* Lance les vidéos visibles, met en pause les autres */
      setupAutoplay() {
        const videos = this.track.querySelectorAll('video');
        if (!('IntersectionObserver' in window)) {
          videos.forEach((v) => { v.muted = true; v.play().catch(() => {}); });
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              video.muted = video.muted;
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { root: this.track, threshold: 0.6 });
        videos.forEach((v) => this.observer.observe(v));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      getStep() {
        const card = this.track.querySelector('.vcar__card');
        if (!card) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 12;
        return card.offsetWidth + gap;
      }

      scrollByCard(direction) {
        this.track.scrollBy({ left: this.getStep() * direction, behavior: 'smooth' });
      }

      scrollToIndex(index) {
        const card = this.track.querySelectorAll('.vcar__card')[index];
        if (card) this.track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      }

      updateState() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 4;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 4;

        if (this.dots.length) {
          const step = this.getStep();
          const active = step > 0 ? Math.round(this.track.scrollLeft / step) : 0;
          this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
        }
      }
    }
    customElements.define('video-carousel-track', VideoCarouselTrack);
  }

  } catch(e) { console.error(e); }
})();
})();
